import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import EditableTitle from "./InputComponents/EditableTitle";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import Tooltip from "./InputComponents/Tooltip";

interface ProjectDevelopmentProps {
  errors: string[];
  isCBE: boolean;
  data: {
    circularProcesses: string;
    circularProcessesText: string;
    circularProcessesSensitive: boolean;

    reduceGHG: string;
    reduceGHGText: string;
    reduceGHGSensitive: boolean;

    zeroWaste: string;
    zeroWasteText: string;
    zeroWasteSensitive: boolean;

    zeroPollution: string;
    zeroPollutionText: string;
    zeroPollutionSensitive: boolean;

    energyEfficiency: string;
    energyEfficiencyText: string;
    energyEfficiencySensitive: boolean;
  };
  customLabelValues : {
    table : string;
    property: string;
    value: string;
    id :string;
  }[];
  tAndP : 
    {
      table : string;
      property :string;
      tooltip : string;
      placeholder : string;
      id : string;
    }[];
  handleOnChangeProjectDevelopment: (e: React.ChangeEvent<any>) => void;
  handleUpdateEditableTitle : (id : string, value: string)=>void;
}

function ProjectDevelopment({
  data,
  handleOnChangeProjectDevelopment,
  errors,
  customLabelValues, 
  handleUpdateEditableTitle,
  tAndP
}: ProjectDevelopmentProps) {
  return (
    <>
      <div className="error-container">
        {errors.map((error, index) => (
          <div
            className="error-text"
            key={index}
            style={{ marginBottom: "10px" }}
          >
            {error}
          </div>
        ))}
      </div>
      <div className="project-dev-question-box">
        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 4.1")?.tooltip}>

        <div className="question-text">
          CBE JU KPI 4.1  🛈 <br />
          <EditableTitle
            customLabelValue={customLabelValues.find(item => item.property == "ReduceGHG")}
            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
        </div>
        </Tooltip>
        <div className="row">
          <div className="col-12">
            <DropdownStringMandatory
              listInputs={["-", "Yes", "No"]}
              label={""}
              inputName={"reduceGHG"}
              value={data.reduceGHG}
              handleOnChange={handleOnChangeProjectDevelopment}
              invalidValues={["-", "", "0"]}
            />
          </div>
          <div className="col-12">
            <TextConfidential
              label={"Please describe the processes improvements and explain in which way these contribute to direct GHG emission reductions, including quantification of the contribution, and how this is calculated and verified."}
              textValid={data.reduceGHGText.length > 4}
              textValue={data.reduceGHGText}
              textName={"reduceGHGText"}
              onChange={handleOnChangeProjectDevelopment}
              isConfidential={data.reduceGHGSensitive}
              confidentialInputName={"reduceGHGSensitive"}
              display={data.reduceGHG != "Yes"}
              placeholder={tAndP.find(item => item.property == "CBE JU KPI 4.1")?.placeholder}
            />
          </div>
        </div>
      </div>
      <div className="project-dev-question-box">
        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 4.2")?.tooltip}>
          <div className="question-text">
          CBE JU KPI 4.2  🛈
          <br />
          <EditableTitle
            customLabelValue={customLabelValues.find(item => item.property == "ZeroWaste")}
            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
        </div>
        </Tooltip>
        <div className="row">
          <div className="col-12">
            <DropdownStringMandatory
              listInputs={["-", "Yes", "No"]}
              label={""}
              inputName={"zeroWaste"}
              value={data.zeroWaste}
              handleOnChange={handleOnChangeProjectDevelopment}
              invalidValues={["-", "", "0"]}
            />
          </div>
          <div className="col-12">
            <TextConfidential
              label={"Please describe the process improvements and explain in which way these contribute to resource efficiency and zero waste, including quantification of the contribution, and how this is calculated and verified"}
              textValid={data.zeroWasteText.length > 4}
              textValue={data.zeroWasteText}
              textName={"zeroWasteText"}
              onChange={handleOnChangeProjectDevelopment}
              display={data.zeroWaste != "Yes"}
              isConfidential={data.zeroWasteSensitive}
              confidentialInputName={"zeroWasteSensitive"}
              placeholder={tAndP.find(item => item.property == "CBE JU KPI 4.2")?.placeholder}
            />
          </div>
        </div>
      </div>
      <div className="project-dev-question-box">
        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 4.3")?.tooltip}>
          <div className="question-text">
          CBE JU KPI 4.3  🛈 <br />
          <EditableTitle
            customLabelValue={customLabelValues.find(item => item.property == "ZeroPollution")}
            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
        </div>
        </Tooltip>
        <div className="row">
          <div className="col-12">
            <DropdownStringMandatory
              listInputs={["-", "Yes", "No"]}
              label={""}
              inputName={"zeroPollution"}
              value={data.zeroPollution}
              handleOnChange={handleOnChangeProjectDevelopment}
              invalidValues={["-", "", "0"]}
            />
          </div>
          <div className="col-12">
            <TextConfidential
              label={"Please describe the process improvements and explain in which way these contribute to zero pollution, including quantification of the contribution, and how this is calculated and verified"}
              textValid={data.zeroPollutionText.length > 4}
              textValue={data.zeroPollutionText}
              textName={"zeroPollutionText"}
              onChange={handleOnChangeProjectDevelopment}
              display={data.zeroPollution != "Yes"}
              isConfidential={data.zeroPollutionSensitive}
              confidentialInputName={"zeroPollutionSensitive"}
              placeholder={tAndP.find(item => item.property == "CBE JU KPI 4.3")?.placeholder}
            />
          </div>
        </div>
      </div>
      <div className="project-dev-question-box">
        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 4.4")?.tooltip}>
          <div className="question-text">
          CBE JU KPI 4.4  🛈 <br />
          <EditableTitle
            customLabelValue={customLabelValues.find(item => item.property == "EnergyEfficiency")}
            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
        </div>
        </Tooltip>
        <div className="row">
          <div className="col-12">
            <DropdownStringMandatory
              listInputs={["-", "Yes", "No"]}
              label={""}
              inputName={"energyEfficiency"}
              value={data.energyEfficiency}
              handleOnChange={handleOnChangeProjectDevelopment}
              invalidValues={["-", "", "0"]}
            />
          </div>
          <div className="col-12">
            <TextConfidential
              label={"Please describe the process improvements and explain in which way these contribute to improve energy efficiency, including quantification of the contribution, and how this is calculated and verified."}
              textValid={data.energyEfficiencyText.length > 4}
              textValue={data.energyEfficiencyText}
              textName={"energyEfficiencyText"}
              onChange={handleOnChangeProjectDevelopment}
              display={data.energyEfficiency != "Yes"}
              isConfidential={data.energyEfficiencySensitive}
              confidentialInputName={"energyEfficiencySensitive"}
              placeholder={tAndP.find(item => item.property == "CBE JU KPI 4.4")?.placeholder}
              />
          </div>
        </div>
      </div>
      <div className="project-dev-question-box">
        <Tooltip content={tAndP.find(item => item.property == "CBE JU KPI 5.2")?.tooltip}>
          <div className="question-text">
          CBE JU KPI 5.2  🛈 <br />
          <EditableTitle
            customLabelValue={customLabelValues.find(item => item.property == "CircularProcesses")}
            handleUpdateEditableTitle={handleUpdateEditableTitle}/>
        </div>
        </Tooltip>
        <div className="row">
          <div className="col-12">
            <DropdownStringMandatory
              listInputs={["-", "Yes", "No"]}
              label={""}
              inputName={"circularProcesses"}
              value={data.circularProcesses}
              handleOnChange={handleOnChangeProjectDevelopment}
              invalidValues={["-", "", "0"]}
            />
          </div>
          <div className="col-12">
            <TextConfidential
              label={"Please explain"}
              textValid={data.circularProcessesText.length > 4}
              textValue={data.circularProcessesText}
              textName={"circularProcessesText"}
              onChange={handleOnChangeProjectDevelopment}
              display={data.circularProcesses != "Yes"}
              isConfidential={data.circularProcessesSensitive}
              confidentialInputName={"circularProcessesSensitive"}
              placeholder={tAndP.find(item => item.property == "CBE JU KPI 5.2")?.placeholder}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectDevelopment;
